import React, { useEffect, useState } from "react";
import "./settings.css";

// components imports
import Loader from "../../../../../../../Components/CircularLoader/CircularLoader";
import SkeletonLoading from "../../../../../../../Components/SkeletonLoading/SkeletonLoading";
// apis imports
import {
  fetchBankDetails,
  createBankDetails,
} from "../../../../../../../services/ShipperServices/Payments/payments.services";
// library imports
import BankTransfer from "../../../../../../../assets/images/bank-transfer.png";
import ETransfer from "../../../../../../../assets/images/e-transfer.png";
import {
  FcNeutralTrading,
  FcReading,
  FcOrganization,
  FcBusinessContact,
  FcDepartment,
  FcFeedback,
  FcUnlock,
} from "react-icons/fc";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Settings = ({ setSnack }) => {
  const { t } = useTranslation("finances");
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);

  const [preservedData, setPreservedData] = useState(null);
  const [changed, setchanged] = useState(false);
  const [data, setData] = useState(null);

  let array = [
    {
      headerTitle: t("addBalance.bank"),
      headerImg: BankTransfer,
      type: "bank_transfer",
    },
    {
      headerTitle: t("addBalance.eTransfer"),
      headerImg: ETransfer,
      type: "e_transfer",
    },
  ];

  useEffect(() => {
    const getBankDetails = async () => {
      try {
        setSkeletonLoading(true);
        const response = await fetchBankDetails(user.warehouse_id);
        if (response.error) {
          setSkeletonLoading(false);
          console.log(response.error);
        } else {
          setData(response.data.result);
          setPreservedData(response.data.result);
          setSkeletonLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getBankDetails();
  }, []);

  useEffect(() => {
    if (
      data?.transit !== preservedData?.transit ||
      data?.institution !== preservedData?.institution ||
      data?.bank_name !== preservedData?.bank_name ||
      data?.code !== preservedData?.code ||
      data?.account_title !== preservedData?.account_title ||
      data?.mail !== preservedData?.mail ||
      data?.account_no !== preservedData?.account_no
    ) {
      setchanged(true);
    } else {
      setchanged(false);
    }
  }, [data]);

  const handelChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    setLoading(true);
    const response = await createBankDetails(data, user.warehouse_id);
    if (!response.error) {
      setData(response.data.result);
      setPreservedData(response.data.result);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("ltl.bankUpdated"),
          severity: "success",
        };
      });
      setLoading(false);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
      setLoading(false);
    }
  };
  return (
    <>
      <div className="settings__3pl_mainwrapper">
        <div className="settings__3pl_boxwrapper">
          {array.map((item, index) => {
            return (
              <div className="settings__3pl_box" key={index}>
                <div className="settings__3pl_header">
                  <div className="settings__3pl_methodicon">
                    <img src={item.headerImg} alt="" />
                  </div>
                  <div className="settings__3pl_heading">
                    {item.headerTitle}
                  </div>
                </div>

                <div className="settings__3pl_boxcontent">
                  {item.type === "bank_transfer" && (
                    <div
                      className={`settings__3pl_boxcontentbox settings__3pl_boxcontentactivebox`}
                    >
                      <div className="settings__3pl_boxtxtrow">
                        <div className="settings__3pl_modaltxtlft">
                          <FcReading size={25} />
                          {t("addBalance.accountTitle")}
                        </div>
                        <div className="settings__3pl_modaltxtrt">
                          {skeletonLoading ? (
                            <SkeletonLoading height={50} />
                          ) : (
                            <input
                              className="settings__3pl_modalinput"
                              placeholder={t("addBalance.accountTitle")}
                              name="account_title"
                              value={data?.account_title}
                              onChange={handelChange}
                              type="text"
                            />
                          )}
                        </div>
                      </div>

                      <div className="settings__3pl_boxtxtrow">
                        <div className="settings__3pl_modaltxtlft">
                          <FcBusinessContact size={25} />
                          {t("addBalance.account")}
                        </div>
                        <div className="settings__3pl_modaltxtrt">
                          {skeletonLoading ? (
                            <SkeletonLoading height={50} />
                          ) : (
                            <>
                              <input
                                className="settings__3pl_modalinput"
                                placeholder={t("addBalance.accountNo")}
                                name="account_no"
                                value={data?.account_no}
                                onChange={handelChange}
                                type="text"
                              />
                            </>
                          )}
                        </div>
                      </div>

                      <div className="settings__3pl_boxtxtrow">
                        <div className="settings__3pl_modaltxtlft">
                          <FcNeutralTrading size={25} />
                          {t("addBalance.transit")}
                        </div>
                        <div className="settings__3pl_modaltxtrt">
                          {skeletonLoading ? (
                            <SkeletonLoading height={50} />
                          ) : (
                            <>
                              <input
                                className="settings__3pl_modalinput"
                                placeholder={t("addBalance.transit")}
                                name="transit"
                                value={data?.transit}
                                onChange={handelChange}
                                type="text"
                              />
                            </>
                          )}
                        </div>
                      </div>

                      <div className="settings__3pl_boxtxtrow">
                        <div className="settings__3pl_modaltxtlft">
                          <FcOrganization size={25} />
                          {t("addBalance.institution")}
                        </div>
                        <div className="settings__3pl_modaltxtrt">
                          {skeletonLoading ? (
                            <SkeletonLoading height={50} />
                          ) : (
                            <>
                              <input
                                className="settings__3pl_modalinput"
                                placeholder={t("addBalance.institution")}
                                name="institution"
                                value={data?.institution}
                                onChange={handelChange}
                                type="text"
                              />
                            </>
                          )}
                        </div>
                      </div>

                      <div className="settings__3pl_boxtxtrow">
                        <div className="settings__3pl_modaltxtlft">
                          <FcDepartment size={25} /> {t("addBalance.bankName")}
                        </div>
                        <div className="settings__3pl_modaltxtrt">
                          {skeletonLoading ? (
                            <SkeletonLoading height={50} />
                          ) : (
                            <>
                              <input
                                className="settings__3pl_modalinput"
                                placeholder={t("addBalance.bankName")}
                                name="bank_name"
                                value={data?.bank_name}
                                onChange={handelChange}
                                type="text"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {item.type === "e_transfer" && (
                    <div
                      className={`settings__3pl_boxcontentbox settings__3pl_boxcontentactivebox`}
                    >
                      <div className="settings__3pl_boxtxtrow">
                        <div className="settings__3pl_modaltxtlft">
                          <FcFeedback size={25} />
                          {t("addBalance.id")}
                        </div>
                        <div className="settings__3pl_modaltxtrt">
                          {skeletonLoading ? (
                            <SkeletonLoading height={50} />
                          ) : (
                            <>
                              <input
                                className="settings__3pl_modalinput"
                                placeholder={t("addBalance.id")}
                                name="mail"
                                value={data?.mail}
                                onChange={handelChange}
                                type="text"
                              />
                            </>
                          )}
                        </div>
                      </div>
                      <br />
                      <div className="settings__3pl_boxtxtrow">
                        <div className="settings__3pl_modaltxtlft">
                          <FcUnlock size={25} />
                          {t("addBalance.code")}
                        </div>
                        <div className="settings__3pl_modaltxtrt">
                          {skeletonLoading ? (
                            <SkeletonLoading height={50} />
                          ) : (
                            <>
                              <input
                                className="settings__3pl_modalinput"
                                placeholder={t("addBalance.code")}
                                name="code"
                                value={data?.code}
                                onChange={handelChange}
                                type="text"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        {changed && (
          <div className="settings__3pl_boxfooter">
            <div className="settings__3pl_boxcncl">{t("common:actions.cancel")}</div>
            <div className={`settings__3pl_boxsave`} onClick={handleSave}>
              {loading ? <Loader /> : t("common:actions.save")}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Settings;
